<template>
  <label :for="fieldId" class="pt-1">
    <span>{{ fieldLabel }}</span>
    <span v-if="config.showAvailable !== false && optionsCount" class="pl-1">({{ optionsCount }} available)</span>
    <span v-if="config.showRequired" class="text-xs pl-1 text-red-800">(Required)</span>
    <span v-if="config.showTooltipIcon" v-tooltip.top="config.tooltipConfig" class="pl-1 text-gray-400">
      <font-awesome-icon :icon="'info-circle'"/>
    </span>
  </label>
</template>
<script>

export default {
  name: 'RMSFieldLabel',
  props: {
    fieldId: {
      type: String,
      default: 'rms-field'
    },
    fieldLabel: {
      type: String,
      default: '--Label--'
    },
    config: {
      type: Object,
      default: () => {},
    },
    optionsCount: {
      type: Number,
      default: () => {},
    },
  },
}
</script>
